import { useCallback } from 'react';
import { useUpdateInsightsShowActiveSubGoalsMutation } from 'shared/hooks/queries/use-update-insights-show-active-sub-goals-mutation';

export const useToggleSubGoals = () => {
  const { mutate } = useUpdateInsightsShowActiveSubGoalsMutation();

  return useCallback((checked: boolean) => mutate(checked), [mutate]);
};
